export default function WorkETF3() {
  return (
    <section className="py-16">
      <div className="sm:w-11/12 mx-auto px-4 sm:px-0">

        {/* Title and subtitle */}
        <div className="text-center mb-20">
          <h2 className="font-black text-black text-3xl sm:text-5xl mb-2">
            Bistro23
          </h2>
          <p className="text-gray-600 font-medium text-base sm:text-lg">
            Your go-to spot for food that hits the soul
          </p>
        </div>

        {/* Full width image */}
        <div className="rounded-3xl overflow-hidden w-full">
          <img
            src="/bistro.jpg"
            alt="Enugu Tech Festival"
            className="hidden sm:block w-full h-auto object-contain relative"
          />

          <img
            src="/bistro.jpg" 
            alt="Hook hero mobile"
            className=" w-full object-cover block sm:hidden"
          />
        </div>

      </div>
    </section>
  );
}